"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ArrayInputType;

(function (ArrayInputType) {
  ArrayInputType["string"] = "string";
  ArrayInputType["number"] = "number";
  ArrayInputType["object"] = "object";
})(ArrayInputType = exports.ArrayInputType || (exports.ArrayInputType = {}));